import moment from 'moment'

const PERIOD_TYPE = {
  YEARLY: 'Yearly',
  QUARTERLY: 'Quarterly',
  MONTHLY: 'Monthly',
}

export const convertDataCreditChartRiskScore = (data, type) => {
  const key = getMonthAndYearInDataRange(data, type)

  const dataKeyColumn = key.map((value) => {
    return data.filter((item) =>
      type === PERIOD_TYPE.MONTHLY
        ? item.month === value.month && item.year === value.year
        : type === PERIOD_TYPE.YEARLY
        ? item.year === value.year
        : item.quarter === value.quarter && item.year === value.year,
    )
  })

  const dataReal = dataKeyColumn.map((item) => {
    let obj = {}
    item.forEach((key) => {
      obj[`description${key.typeOrder}`] = key.description
      obj['ticker'] =
        type === PERIOD_TYPE.YEARLY
          ? key.year
          : type === PERIOD_TYPE.MONTHLY
          ? covertToMMMYYYY(key.month, key.year)
          : `Q${key.quarter}-${key.year}`
      obj[`data${key.typeOrder}`] = key.scoreValue
      obj['year'] = key.year
      obj['month'] = key.month
      obj[`dataFloatBar${key.typeOrder}`] = [
        key?.interquartileLower,
        key?.interquartileUpper,
      ]
    })
    return obj
  })

  return dataReal
}

const covertToMMMYYYY = (month, year) => {
  return moment(`${month}/${year}`, 'MM/YYYY').format('MMM-YYYY')
}

const getMonthAndYearInDataRange = (data, type = PERIOD_TYPE.YEARLY) => {
  return data
    .map((item) => ({
      month: item?.month,
      year: item?.year,
      quarter: item?.quarter,
    }))
    ?.filter(
      (value, index, self) =>
        index ===
        self.findIndex((t) =>
          type === PERIOD_TYPE.MONTHLY
            ? t.month === value.month && t.year === value.year
            : type === PERIOD_TYPE.QUARTERLY
            ? t.quarter === value.quarter && t.year === value.year
            : t.year === value.year,
        ),
    )
    .sort((a, b) => {
      if (a.year === b.year) {
        if (type === PERIOD_TYPE.MONTHLY) {
          if (a.month < b.month) return -1
        }
        if (type === PERIOD_TYPE.QUARTERLY) {
          if (a.quarter < b.quarter) return -1
        }
        return 0
      } else {
        if (a.year < b.year) return -1
      }
      return 0
    })
}
